module.exports = __webpack_public_path__ + "img/Jersey.bd50e25b.svg";